import script from "./payroll-bank-transfer-templates.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-bank-transfer-templates.vue?vue&type=script&setup=true&lang=js"

import "./payroll-bank-transfer-templates.vue?vue&type=style&index=0&id=bdccb99c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdccb99c"]])

export default __exports__